if (!customElements.get('product-collapsible')) {
	customElements.define(
		'product-collapsible',
		class ProductCollapsible extends HTMLElement {
			connectedCallback() {
				// Remove any previously appended drawer for this instance
				if (this._drawerAppended && this._drawerAppended.parentNode === document.body) {
					this._drawerAppended.remove();
				}

				// Find preview and drawer inside this collapsible
				const preview = this.querySelector('product-collapsible-preview');
				const drawer = this.querySelector('product-collapsible-drawer');
				if (!preview || !drawer) {
					this.innerHTML = '';
					this.removeAttribute('available');
					return;
				}

				// Clone and move drawer to body (so each instance manages its own drawer)
				const drawerClone = drawer.cloneNode(true);
				document.body.appendChild(drawerClone);
				this._drawerAppended = drawerClone;

				// Button event to show only this drawer
				const button = preview.querySelector('button');
				if (button) {
					button.addEventListener('click', () => {
						// Hide all other product-collapsible drawers
						document.querySelectorAll('product-collapsible-drawer[open]').forEach(d => {
							if (d !== drawerClone) d.hide();
						});
						// Hide all collapsible-tab drawers
						document.querySelectorAll('collapsible-tab-drawer[open]').forEach(d => {
							d.hide();
						});
						drawerClone.show(button);
					});
				}
			}
		}
	);
}

if (!customElements.get('product-collapsible-drawer')) {
	customElements.define(
		'product-collapsible-drawer',
		class ProductCollapsibleDrawer extends HTMLElement {
			constructor() {
				super();
				this.onBodyClick = this.handleBodyClick.bind(this);
				this.querySelector('button')?.addEventListener('click', () => {
					this.hide();
				});
				this.addEventListener('keyup', (event) => {
					if (event.code.toUpperCase() === 'ESCAPE') this.hide();
				});
			}
			handleBodyClick(evt) {
				const target = evt.target;
				if (
					target !== this &&
					!target.closest('product-collapsible-drawer') &&
					!target.id?.startsWith('ShowCollapsibleTabDrawer')
				) {
					this.hide();
				}
			}
			hide() {
				this.removeAttribute('open');
				document.body.removeEventListener('click', this.onBodyClick);
				document.body.classList.remove('overflow-hidden');
				if (typeof removeTrapFocus === 'function') removeTrapFocus(this.focusElement);
			}
			show(focusElement) {
				this.focusElement = focusElement;
				this.setAttribute('open', '');
				document.body.addEventListener('click', this.onBodyClick);
				document.body.classList.add('overflow-hidden');
				if (typeof trapFocus === 'function') trapFocus(this);
			}
		}
	);
}